import { schema } from 'normalizr';

export const threadSchema = new schema.Entity('thread');
